import React, { Component } from 'react';
import "../index.css";

class Tabs extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        activeTab: 0, // Index of the active tab
      };
    }
  
    // Function to handle tab click
    handleTabClick = (index) => {
      this.setState({ activeTab: index });
    };
  
    render() {
      const { activeTab } = this.state;
      const tabs = React.Children.toArray(this.props.children);
      const tabClassNames = this.props.tabClassNames || [];
  
      return (
        <div className="tabs">
          <ul className="tab-list-container">
            {tabs.map((tab, index) => (
              <li
                key={index}
                className={`tab-item ${index === activeTab ? 'active' : 'inactive-tab'} ${tabClassNames[index] || ''}`}
                onClick={() => this.handleTabClick(index)}
              >
                {tab.props.label}
              </li>
            ))}
          </ul>
          <div className="tab-content">
            {tabs[activeTab]}
          </div>
        </div>
      );
    }
  }
  
  export default Tabs;